import React, { useState } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import Img from '../../../assets/images/main_vector.svg';
import CommonCard from "../../../components/ui/commonCard/CommonCard";
import StakeTabs from "./tabs/Tabs";
import Stake from "./tabs/stake/Stake";
import Unstake from "./tabs/unstake/Unstake";
import { BackArrowIcon } from "../../../assets/svgIcons/svgIcons";
import './HomePage.scss';
interface TabProps {
    key: string;
    title: string;
    children: React.ReactNode;
}
const HomePage: React.FC = () => {
    const [activeTab, setActiveTab] = useState<string>('stake');
    const [activeStep, setActiveStep] = useState(1);
    const handleTabChange = (key: string | null) => {
        if (key !== null) {
            setActiveTab(key);
            if (key === 'stake') {
                setActiveStep(1);
            }
        }
    };
    const handleBack = () => {
        if (activeStep > 1) {
            setActiveStep(activeStep - 1);
        }
    };
    const stakeTabs: TabProps[] = [
        {
            key: 'stake',
            title: 'Stake',
            children: <Stake activeStep={activeStep} setActiveStep={setActiveStep} onBack={handleBack} />,
        },
        {
            key: 'unstake',
            title: 'Unstake',
            children: <Unstake />,
        },
    ];
    return (
        <section className="home">
            <Container>
                <Row className="align-items-center">
                    <Col md={6} className="order-md-last">
                        <div className="home_right">
                            {activeTab === "stake" && <h2>SBTC TVL•. $1.5b</h2>}
                            <CommonCard>
                                {activeTab === 'stake' && activeStep > 1 && (
                                    <button className="back_btn" onClick={handleBack} type="button"><BackArrowIcon /> Back</button>
                                )}
                                <StakeTabs tabs={stakeTabs} onTabChange={handleTabChange} activeKey={activeTab} />
                            </CommonCard>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="home_left">
                            <h1>Stake More, Earn More Rewards</h1>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard</p>
                            <img src={Img} alt="Main Illustration" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
export default HomePage;
